export default "__VITE_ASSET__CYjkTzhX__"